module.exports = __webpack_public_path__ + "static/media/divider.e3816a07.svg";